/**
 * Message Type that can be sent to a ChargePoint
 */
export enum MessageTriggerType {
    BootNotification = 'BootNotification',
    DiagnosticsStatusNotification = 'DiagnosticsStatusNotification',
    FirmwareStatusNotification = 'FirmwareStatusNotification',
    Heartbeat = 'Heartbeat',
    MeterValues = 'MeterValues',
    StatusNotification = 'StatusNotification',
}
